
    export default {
      mounted() {
        this.el.addEventListener("click", () => window.location.reload())
      }
    }
  